export function initialMcpAccountSelection(accounts = []) {
  return accounts.length === 1 ? [accounts[0].account_id] : [];
}

export function mcpAccountLabel(account, fallback) {
  return account?.display_name || account?.phone_number || fallback;
}

export function validateMcpRedirect(value) {
  const redirect = String(value || "");
  const isLocalPath = /^\/(?![\\/])/.test(redirect);
  const url = new URL(redirect, "https://www.min.cool");
  const isLocalHttp = url.protocol === "http:" && ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname);
  if (!redirect || url.username || url.password || (!isLocalPath && !/^https:\/\//.test(redirect) && !isLocalHttp)) {
    throw new Error("Invalid authorization redirect");
  }
  return redirect;
}
